import React from "react";
import styles from "./styles/conditions.module.scss";

export const TermsConditions = () => {
  return (
    <section className={styles.section_terms_conditions}>
      <div className="container">
        <div className={styles.conditions_wrapper}>
          <ul className={styles.main_list}>
            <li className={styles.main_list_item}>
              <h4>1. Privacy Policy</h4>
              The personal information we collect to facilitate the student
              application procedure includes, but is not <br /> limited to:
              <ul className={styles.upper_alpha}>
                <li>Name</li>
                <li>
                  Contact details (including mailing address, phone number,
                  email address)
                </li>
                <li>Date of birth</li>
                <li>Nationality</li>
                <li>Academic history and qualifications</li>
                <li>Employment history and certifications</li>
                <li>Other relevant certifications</li>
                <li>
                  Supplemental documentation including but not limited to copies
                  of:
                  <ul className={styles.lower_alpha}>
                    <li>
                      Passport, birth certificate, driver’s license and/or other
                      identification documents
                    </li>
                    <li>
                      Academic transcripts, certificates, and other relevant
                      documents
                    </li>
                    <li>Academic reference letters</li>
                    <li>
                      Personal statements or other written samples as required
                      by academic institutions
                    </li>
                    <li>
                      Photographs of applicants as required by academic
                      institutions
                    </li>
                    <li>
                      Certifications and score reports of admissions exams such
                      as language proficiency tests and subject-specific
                      aptitude tests (e.g. IELTS, TOEFL, GRE, GMAT, LSAT, etc.)
                    </li>
                    <li>CVs and/or resumes</li>
                    <li>
                      Other information deemed necessary and relevant for higher
                      education applications
                    </li>
                  </ul>
                </li>
              </ul>
              <p className={styles.text}>
                We value the privacy of our users, and are committed to
                protecting your personal information. We ensure that all
                information you provide us with is kept confidential and is
                solely utilised for the purpose of delivering our Services
                effectively. We will only share your personal information with
                relevant third parties involved in the international student
                recruitment process, such as:
              </p>
              <ul className={styles.lower_roman}>
                <li>
                  Academic institutions you have selected to apply to for the
                  purposes of admissions procedures and student records{" "}
                </li>
                <li>
                  Any institution, employer, or other organisation you have
                  included in the information provided to us, for the purposes
                  of verification
                </li>
                <li>
                  Any regulatory or government body in compliance with
                  established and applicable laws
                </li>
              </ul>
              <p className={styles.text}>
                By utilising the UniSearch website and its Services, you agree
                to the collection of your personal information within the fair
                and reasonable bounds specified above.
              </p>
            </li>

            <li className={styles.main_list_item}>
              <h4>2. Cookies Policy</h4>
              We use Cookies to personalise and create a responsive and
              user-friendly experience for you. For instance, Cookies help you
              resume previous searches, locate pages you have visited before and
              find similar content you may be interested in browsing. They also
              help us keep track of our website analytics to adjust and adapt
              our Services for the best user experience. If you disable Cookies,
              you can still access the website; you may, however, experience
              limited functionality.
            </li>

            <li className={styles.main_list_item}>
              <h4>3. Intellectual Property Policy</h4>
              All intellectual property - including logos, written, video,
              audio, graphic and other content, web design, and so on - of
              UniSearch is licensed and protected under Australian and
              international intellectual property laws. <br /> We prohibit:
              <ul className={styles.lower_roman}>
                <li>
                  Republishing or reproducing our intellectual property on other
                  sites
                </li>
                <li>Unauthorised downloads of intellectual property</li>
                <li>
                  Unauthorised usage of intellectual property for third-party
                  commercial use
                </li>
                <li>
                  Claiming UniSearch’s intellectual property as belonging to a
                  third party (including the user)
                </li>
                <li>
                  Attempts to revise, remove, or otherwise interfere or tamper
                  with the UniSearch website and its intellectual property and
                  assets
                </li>
                <li>Unauthorised distribution of our intellectual property</li>
              </ul>
            </li>

            <li className={styles.main_list_item}>
              <h4>4. User Conduct</h4>
              As a user of our Services you agree that:
              <ul className={styles.lower_roman}>
                <li>
                  All information you provide us with - including personal
                  information and mandatory and supplemental documents to build
                  and support your higher education applications - is accurate,
                  complete, and up-to-date
                </li>
                <li>
                  You will not misrepresent information or use a false identity
                  to utilise our Services
                </li>
                <li>
                  You will not pretend to represent a member of UniSearch or
                  affiliated entity
                </li>
                <li>
                  You will not collect, store and use the personal information
                  of other users or otherwise interfere with the accounts,
                  applications and other processes undertaken by other users
                </li>
                <li>
                  You will not engage in malicious behaviours including but not
                  limited to spamming, using inappropriate language, abusing our
                  Services, harassing our users, UniSearch personnel or
                  affiliated entities, through UniSearch forums, chat functions
                  or other channels and communication mediums
                </li>
                <li>
                  You will comply with all applicable rules and regulations,
                  including all relevant laws and the Terms of this agreement{" "}
                </li>
                <li>
                  UniSearch may at its sole discretion review your account and
                  suspend or block it should it be deemed necessary
                </li>
                <li> Multiple accounts for a single user are prohibited</li>
              </ul>
            </li>

            <li className={styles.main_list_item}>
              <h4>5. Limitations of Liability</h4>
              By using our website and associated Services, you understand that
              we:
              <ul className={styles.lower_roman}>
                <li>
                  Have no control over the final admissions decision of the
                  academic institutions you apply to
                </li>
                <li>
                  Cannot guarantee that the academic institutions you apply to
                  will prioritise or process your application
                </li>
                <li>
                  Do not guarantee that our Services will be delivered without
                  interruptions and/or be error-free. We account for human error
                  as well as Services disruption due to maintenance, network
                  failures, and other technical difficulties
                </li>
                <li>
                  Shall not be held liable for any damages including but not
                  limited to the loss of profits or revenue, personal
                  information, data corruption, software failure, etc. incurred
                  by you or by any third party using our Services
                </li>
                <li>
                  Cannot ensure that all information displayed on the website is
                  up-to-date and current at all times
                </li>
                <li>
                  Do not endorse the personal opinions and views expressed by
                  members of the UniSearch community, counsellors, mentors, and
                  other personnel and affiliated entities through forums, chats,
                  and so forth
                </li>
                <li>
                  Do not claim that all the information provided through our
                  contents is a complete representation of the distinct
                  requirements and characteristics of academic institutions and
                  study abroad destinations
                </li>
                <li>
                  Do not claim that all information provided through our
                  contents is error-free and accurate
                </li>
              </ul>
            </li>

            <li className={styles.main_list_item}>
              <h4>6. Governing Laws</h4>
              These Terms are governed by and shall be construed in accordance
              with the law applicable in New South Wales and the parties submit
              to the exclusive jurisdiction of the courts of New South Wales and
              any court having jurisdiction to hear appeals from those courts.
            </li>
            <li className={styles.main_list_item}>
              <h4>7. Acceptance</h4>
              You agree that by continuing to use the UniSearch website and all
              associated Services that you have read our Terms and related
              policies and accept these conditions.
            </li>

            <li>
              <h4>8. Google DoubleClick DART Cookie</h4>
              <p>
                Google is one of a third-party vendor on our site. It also uses
                cookies, known as DART cookies, to serve ads to our site
                visitors based upon their visit to www.website.com and other
                sites on the internet. However, visitors may choose to decline
                the use of DART cookies by visiting the Google ad and content
                network Privacy Policy at the following URL –
                <a
                  color="#f47f20"
                  target="_blank"
                  rel="nofollow"
                  href="https://policies.google.com/technologies/ads"
                >
                  https://policies.google.com/technologies/ads
                </a>
              </p>
            </li>
            <li>
              <h4>9. Our Advertising Partners</h4>
              <p>
                Some of advertisers on our site may use cookies and web beacons.
                Our advertising partners are listed below. Each of our
                advertising partners has their own Privacy Policy for their
                policies on user data. For easier access, we hyperlinked to
                their Privacy Policies below.
                <ul className={styles.lower_roman}>
                  <li>
                    <a
                      color="#f47f20"
                      target="_blank"
                      rel="nofollow"
                      href="https://policies.google.com/technologies/ads"
                    >
                      Google
                    </a>
                  </li>
                </ul>
              </p>
            </li>
            <li>
              <h4>10. Advertising Partners Privacy Policies</h4>
              <p>
                You may consult this list to find the Privacy Policy for each of
                the advertising partners of UniSearch
              </p>
              <p>
                Third-party ad servers or ad networks uses technologies like
                cookies, JavaScript, or Web Beacons that are used in their
                respective advertisements and links that appear on UniSearch,
                which are sent directly to users' browser. They automatically
                receive your IP address when this occurs. These technologies are
                used to measure the effectiveness of their advertising campaigns
                and/or to personalize the advertising content that you see on
                websites that you visit.
              </p>
              <p>
                Note that UniSearch has no access to or control over these
                cookies that are used by third-party advertisers
              </p>
            </li>
            <li>
              <h4>11. Third Party Privacy Policies</h4>
              <p>
                UniSearch's Privacy Policy does not apply to other advertisers
                or websites. Thus, we are advising you to consult the respective
                Privacy Policies of these third-party ad servers for more
                detailed information. It may include their practices and
                instructions about how to opt-out of certain options
              </p>
              <p>
                You can choose to disable cookies through your individual
                browser options. To know more detailed information about cookie
                management with specific web browsers, it can be found at the
                browsers' respective websites.
              </p>
            </li>
            <li>
              <h4>
                12. CCPA Privacy Rights (Do Not Sell My Personal Information)
              </h4>
              <p>
                Under the CCPA, among other rights, California consumers have
                the right to:
              </p>
              <p>
                Request that a business that collects a consumer's personal data
                disclose the categories and specific pieces of personal data
                that a business has collected about consumers.
              </p>
              <p>
                Request that a business delete any personal data about the
                consumer that a business has collected.
              </p>
              <p>
                Request that a business that sells a consumer's personal data,
                not sell the consumer's personal data.
              </p>
              <p>
                If you make a request, we have one month to respond to you. If
                you would like to exercise any of these rights, please contact
                us.
              </p>
            </li>
            <li>
              <h4>13. GDPR Data Protection Rights</h4>
              <p>
                We would like to make sure you are fully aware of all of your
                data protection rights. Every user is entitled to the following:
              </p>
              <p>
                The right to access – You have the right to request copies of
                your personal data. We may charge you a small fee for this
                service.
              </p>
              <p>
                The right to rectification – You have the right to request that
                we correct any information you believe is inaccurate. You also
                have the right to request that we complete the information you
                believe is incomplete.
              </p>
              <p>
                The right to erasure – You have the right to request that we
                erase your personal data, under certain conditions.
              </p>
              <p>
                The right to restrict processing – You have the right to request
                that we restrict the processing of your personal data, under
                certain conditions.
              </p>
              <p>
                The right to object to processing – You have the right to object
                to our processing of your personal data, under certain
                conditions.
              </p>
              <p>
                The right to data portability – You have the right to request
                that we transfer the data that we have collected to another
                organization, or directly to you, under certain conditions.
              </p>
              <p>
                If you make a request, we have one month to respond to you. If
                you would like to exercise any of these rights, please contact
                us.
              </p>
            </li>
            <li>
              <h4>14. Changes to This Privacy Policy</h4>
              <p>
                We may update our Privacy Policy from time to time. Thus, we
                advise you to review this page periodically for any changes. We
                will notify you of any changes by posting the new Privacy Policy
                on this page. These changes are effective immediately, after
                they are posted on this page
              </p>
              <p>
                Our Privacy Policy was created with the help of the Privacy
                Policy Generator.
              </p>
            </li>
            <li>
              <h4>15. Contact Us</h4>
              <p>
                If you have any questions or suggestions about our Privacy
                Policy, do not hesitate to{" "}
                <a
                  color="#f47f20"
                  href="https://myunisearch.com/contact-us"
                  target="_blank"
                >
                  contact us
                </a>
                .
              </p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default TermsConditions;
